import { graphqlClient } from "../../../client";
import mutationDocument from "./resetInitialPasswordByToken.graphql";
import type {
  IdentityResultType,
  InputResetPasswordByTokenType,
  Mutations,
  MutationsResetPasswordByTokenArgs,
} from "@/core/api/graphql/types";

export async function resetInitialPasswordByToken(payload: InputResetPasswordByTokenType): Promise<IdentityResultType> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "resetInitialPasswordByToken">>,
    MutationsResetPasswordByTokenArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: payload,
    },
  });

  return data!.resetInitialPasswordByToken;
}
